module.exports = "<div class=\"wrapper\">\n    <div class=\"sidebar\" data-color=\"light\">\n        <app-sidebar></app-sidebar>\n    </div>\n    <div class=\"main-panel\">\n        <flash-messages></flash-messages>\n        <app-navbar></app-navbar>\n        <router-outlet></router-outlet>\n        <app-footer></app-footer>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/group-layout/group-layout.component.html
// module id = ./src/app/layouts/group-layout/group-layout.component.html
// module chunks = main